import { useEffect, useState } from 'react'

import { t } from '../i18n/lingua'

/**
 * «Cosa fa?» accanto a un'opzione, e la spiegazione in una finestra.
 *
 * Per le opzioni che cambiano **che cosa** si legge e con quali permessi (per
 * esempio l'import avanzato dei connettori cloud): un suggerimento di una riga
 * sotto la casella non basta a decidere, e un paragrafo intero sotto ogni
 * casella rende il modulo illeggibile. I paragrafi arrivano dal catalogo del
 * Control Plane (`CredentialField.explain`) e passano da `t()`.
 */
export function Spiegazione({ titolo, paragrafi }: { titolo: string; paragrafi: string[] }) {
  const [aperta, setAperta] = useState(false)

  useEffect(() => {
    if (!aperta) return
    const chiudi = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setAperta(false)
    }
    window.addEventListener('keydown', chiudi)
    return () => window.removeEventListener('keydown', chiudi)
  }, [aperta])

  if (paragrafi.length === 0) return null
  return (
    <>
      <button type="button" className="link spiegazione__apri" onClick={() => setAperta(true)}>
        ⓘ {t('Cosa fa?')}
      </button>
      {aperta && (
        <div className="dob-modal" role="dialog" aria-modal="true" aria-label={titolo}>
          <div className="dob-modal__scrim" onClick={() => setAperta(false)} />
          <div className="dob-modal__pannello spiegazione__pannello">
            <div className="dob-modal__testata">
              <h3 className="dob-modal__titolo">{titolo}</h3>
              <button type="button" className="secondary" onClick={() => setAperta(false)}>
                {t('Chiudi')}
              </button>
            </div>
            <div className="dob-modal__corpo">
              {paragrafi.map((p) => (
                // A paragraph on several lines is a command: shown as code, not translated.
                p.includes('\n')
                  ? <pre key={p} className="mono" style={{ whiteSpace: 'pre-wrap', fontSize: 12, background: 'var(--surface-alt)', padding: 10, borderRadius: 6 }}>{p}</pre>
                  : <p key={p}>{t(p)}</p>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
